import { MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import footerResource from '../../../locales/th/footer.json';
import { updateModalVisible } from '../../../store/common/slice';
import {
  LeadCaptureWrapper,
  ModalForm,
  ModalFormBody,
  PhoneNumber,
} from './LeadCapture.style';
import LeadForm from './LeadForm';

export const LEAD_CAPTURE_PHONE_NUMBER = '02-204-9598';
const mobileCallPhoneNumber = `tel:${LEAD_CAPTURE_PHONE_NUMBER}`;

interface LeadCaptureProps {
  source?: string;
}

interface LeadCaptureState {
  isShowFullPhoneNumber: boolean;
  isShowMobileFormModel: boolean;
  isCallFunction: boolean;
  leadCaptureTitle?: string;
}
const LeadCapture: React.FC<LeadCaptureProps> = ({ source }) => {
  const [state, setState] = useState<LeadCaptureState>({
    isShowFullPhoneNumber: false,
    isShowMobileFormModel: false,
    isCallFunction: false,
    leadCaptureTitle: footerResource.leadCapture.title,
  });

  const dispatch = useDispatch();

  const showPhoneNumber = () => {
    if (state.isShowFullPhoneNumber) {
      setState((prevState) => ({
        ...prevState,
        isCallFunction: true,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        isShowFullPhoneNumber: true,
      }));
    }
  };

  const showMobileFormModel = () => {
    setState((prevState) => ({
      ...prevState,
      isShowMobileFormModel: true,
    }));
    dispatch(updateModalVisible(true));
  };

  const handleCancelFormModel = () => {
    setState((prevState) => ({
      ...prevState,
      isShowMobileFormModel: false,
    }));
    dispatch(updateModalVisible(false));
  };

  const renderFormModel = () => {
    const leadCaptureTitle = footerResource.leadCapture.title;

    return (
      <ModalForm>
        <Modal
          open={state.isShowMobileFormModel}
          onCancel={handleCancelFormModel}
          footer={null}
          wrapClassName="modalFormContent"
          style={{ top: 0, bottom: 0 }}
          styles={{
            body: {
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
            },
          }}
          width={'100%'}
          height={'100%'}
        >
          <ModalFormBody>
            <div className="modal-title">{leadCaptureTitle}</div>
            <div
              className="modal-contact-button"
              role="button"
              tabIndex={0}
              onClick={() => showPhoneNumber()}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  showPhoneNumber();
                }
              }}
            >
              <a href={mobileCallPhoneNumber}>
                <PhoneOutlined className="phone" />
                <span>Call</span>
              </a>
            </div>
            <LeadForm source={source} />
          </ModalFormBody>
        </Modal>
      </ModalForm>
    );
  };

  const leadCaptureSubmitButtonInfo =
    footerResource.leadCapture.form.submitButtonInfo;

  return (
    <LeadCaptureWrapper data-test="lead-capture-form">
      <div className="title">{state.leadCaptureTitle}</div>
      <div className="buttons">
        <div
          className="form-button"
          role="button"
          tabIndex={0}
          onClick={() => showMobileFormModel()}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              showMobileFormModel();
            }
          }}
        >
          <MailOutlined className="mail" />
          <span>{leadCaptureSubmitButtonInfo}</span>
        </div>
        <div
          className="contact-button"
          role="button"
          tabIndex={0}
          onClick={() => showPhoneNumber()}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              showPhoneNumber();
            }
          }}
        >
          <a
            href={
              state.isCallFunction
                ? mobileCallPhoneNumber
                : 'javascript:return false'
            }
          >
            <div>
              <PhoneOutlined className="phone" />
            </div>
            <PhoneNumber isShowFullPhoneNumber={state.isShowFullPhoneNumber}>
              {LEAD_CAPTURE_PHONE_NUMBER}
            </PhoneNumber>
          </a>
        </div>
      </div>
      {state.isShowMobileFormModel && renderFormModel()}
      <div className="lead-form">
        <LeadForm source={source} />
      </div>
    </LeadCaptureWrapper>
  );
};

export default LeadCapture;
